<template>
  <v-flex xs12 sm12 d-block class="card-dados linha card-dados__mobile">
    <h3 class="card-dados__titulo">Notificar Fornecedores por Linha de Fornecimento</h3>

    <a class="d-flex align-center btn-adicionar" v-if="exibirBotaoAdicionar" @click="exibirCampoDeNovaLinha"
       style="display: inline-flex; width: 250px;">
      <v-icon large class="icone-botao" color="#D79641">add_circle</v-icon>Nova Linha de Fornecimento
    </a>

    <div class="area-novo" v-show="!exibirBotaoAdicionar">
      <label>Nova Linha de Fornecimento:</label>

      <v-autocomplete v-model="valor.linhaFornecNova" class="area-novo__input" :items="linhasNaoInseridas"
                      autofocus :search-input.sync="buscarLinhasAutocomplete"
                      placeholder="Informe a linha de fornecimento" :item-text="codigoDescricao"
                      item-value="linhaFornecimentoCodigo - linhaFornecimentoDescricao" name="Descrição"
                      ref="linhaAutocomplete">
      </v-autocomplete>

      <v-tooltip top>
        <v-btn id="botaoAdicionar" slot="activator" outline flat small color="green"
               @click="adicionarLinha(valor.linhaFornecNova)">
          <v-icon size="20">check</v-icon>
        </v-btn>
        Adicionar
      </v-tooltip>

      <v-tooltip top>
        <v-btn id="botaoCancelar" slot="activator" outline flat small color="#777"
               @click="cancelarLinha">
          <v-icon size="20">close</v-icon>
        </v-btn>
        Cancelar
      </v-tooltip>
    </div>

    <v-data-table :headers="colunas" :items="value.items"
                  no-data-text="Não há linhas de fornecimento adicionadas"
                  class="az-table-list tabela-linha">
      <template slot="items" slot-scope="props">
        <td class="btn-adicionar">
          {{props.item.linhaFornecimentoCodigo}} - {{props.item.linhaFornecimentoDescricao}}
        </td>
        <td class="table-actions" >
          <botao-excluir v-show="exibirBotaoExclusao(props.item.origem)" @excluir="exibirDialogoExclusaoLinha(props.item.id)"/>
        </td>
      </template>
    </v-data-table>

    <mensagem-confirmacao :exibirMensagem="mostrarDialogoExclusao"
                          @confirmado="tratarEventoExcluirLinha"
                          @recusado="mostrarDialogoExclusao = false"/>
  </v-flex>
</template>

<script>
import {actionTypes} from '@/commons/constants';
import MensagemConfirmacao from "@/commons/components/MensagemConfirmacao.vue";
import BotaoExcluir from "@/commons/components/BotaoExcluir.vue";

export default {
  name: 'PainelLinhaFornecimentoEdicao',
  components: {MensagemConfirmacao, BotaoExcluir},
  props: {
    value: {
      required: true
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {
      colunas: [
        {
          text: 'Linha de Fornecimento',
          value: 'linhaFornecimentoCodigo',
          sortable: true,
          align: 'left',
          class: 'primary--text'
        },
        {
          text: 'Ações',
          sortable: false,
          align: 'center',
          width: '30px',
          class: 'primary--text'
        }
      ],
      linhaId: null,
      valor: {
        required: true
      },
      mostrarDialogoExclusao: false,
      exibirBotaoAdicionar: true,
      buscarLinhasAutocomplete: null,
      linhasNaoInseridas: []
    }
  },
  async mounted() {
    this.setLicitacaoId(this.$route.params.id)
  },
  methods: {
    async adicionarLinha(buscarLinhasAutocomplete) {
      this.habilitarLoadingGlobal()
      const linhaFornecimento = this.formatarLinhaFornecimento(buscarLinhasAutocomplete)
      this.$emit('adicionarLinhaFornecimento', linhaFornecimento)
      this.cancelarLinha()
    },
    cancelarLinha() {
      this.exibirBotaoAdicionar = true
      this.valor = {}
      this.$validator.reset()
    },
    exibirCampoDeNovaLinha() {
      this.exibirBotaoAdicionar = false
      setTimeout(() => {
        this.focusInput()
      },300)
    },
    exibirDialogoExclusaoLinha(id) {
      this.linhaId = id
      this.mostrarDialogoExclusao = true
    },
    exibirBotaoExclusao(origem) {
      return origem === 'EXTERNA'
    },
    tratarEventoExcluirLinha() {
      this.mostrarDialogoExclusao = false
      this.$emit('excluirLinhaFornecimento', this.linhaId)
    },
    verificarLinhaAdicionada(linhaCodigo) {
      return this.value.items.some(item => item.linhaFornecimentoCodigo === linhaCodigo)
    },
    formatarLinhaFornecimento(codigoDescricao) {
      let linha = {}
      const resultado = codigoDescricao.split(' - ')
      const codigo = resultado[0]
      const descricao = resultado[1]
      linha.linhaFornecimentoCodigo = codigo
      linha.linhaFornecimentoDescricao = descricao
      return linha
    },
    focusInput() {
      this.$refs.linhaAutocomplete.focus()
    },
    setLicitacaoId(licitacaoId) {
      this.licitacaoId = licitacaoId
    },
    codigoDescricao(item) {
      return `${item.linhaFornecimentoCodigo} - ${item.linhaFornecimentoDescricao}`;
    }
  },
  watch: {
    async buscarLinhasAutocomplete(linha) {
      if (linha && linha.length > 1) {
        try {
          this.desabilitarLoadingGlobal()
          const linhasNaoInseridas = []
          const linhasRetornoBuscar = await this.$store.dispatch(actionTypes.BUSCAR_LINHAS_FORNECIMENTO_EXTERNAS, linha)
          linhasRetornoBuscar.items.forEach(linhaFornec => {
            if (!this.verificarLinhaAdicionada(linhaFornec.linhaFornecimentoCodigo)) {
              linhasNaoInseridas.push(linhaFornec)
            }
          })
          this.linhasNaoInseridas = linhasNaoInseridas
          this.focusInput()
        } catch (e) {
          this.mostrarNotificacaoErro(e.message)
        }
      }
    }
  }
}
</script>

<style scoped lang="stylus">
.table-actions
  text-align center !important

  a
    color #777
    display inline-flex
    align-items center
    justify-content center

  i
    font-size 16px

.linha div[role="listitem"]
  display none

.tabela-linha
  padding 10px 16px 16px

.btn-adicionar
  border 0
  color #777 !important
  padding 0
  margin 0 0 0 16px

  &:hover:before, &:focus:before, &:active:before
    background-color #fff

  .icone
    background-color #D79641
    padding 6px
    border-radius 20px
    margin-right 8px

@media (max-width 720px)
  .linha .btn-adicionar
    margin-bottom 10px

  .tabela-linha
    padding 0

    td:nth-of-type(1):before
      content "Linha de Fornecimento:"

    td:nth-of-type(2):before
      display none

</style>